import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpStaticLoader } from "@husbanken/angular-starter";
import { provideTranslations as provideCoreTranslations } from "@husbanken/designsystem-angular-core";
import { provideTranslations as provideFormsTranslations } from "@husbanken/designsystem-angular-forms";
import { provideTranslations as provideHeaderTranslations } from "@husbanken/designsystem-angular-header-v2";
import { provideTranslations as provideTimeoutTranslations } from "@husbanken/designsystem-angular-timeout";
import { provideTranslations as provideSkjemarammeverkTranslations } from "@husbanken/rzrforms-lib";
import { Provider } from "@angular/core";

export interface HbI18nOptions {
  cacheVersion: string;
}

export function provideHbI18n({ cacheVersion }: HbI18nOptions): Provider {
  return [
    provideCoreTranslations(),
    provideFormsTranslations(),
    provideHeaderTranslations(),
    provideSkjemarammeverkTranslations(),
    provideTimeoutTranslations(),
    provideTranslateService({
      defaultLanguage: "nb",
      extend: true,
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: (http: HttpClient) => new TranslateHttpStaticLoader(http, cacheVersion),
      },
    }),
  ];
}
